import React, { useState, useRef, useEffect } from 'react';
import { Hidden } from '@material-ui/core';
import MainPlaybar from './MainPlaybar/MainPlaybar';
import MiniPlaybar from './MiniPlaybar';

export default function Playbar(props) {
  const {
    location,
    stationid,
    title,
    image,
    country,
    state,
    heartedStationIds,
    onFavouriteRadioStation,
    onDeleteHeartRadioStation,
    onShowSnackbarNotification,
    onAddPlayRadioStationStart,
    onRatingHandleStart
  } = props;

  const audioPlayer = useRef();
  const player = audioPlayer.current;

  const [audioState, setAudioState] = useState(null);
  const [stateVolume, setStateVolume] = useState(0.3);
  const [previousVolume, setPreviousVolume] = useState(0.3);
  const [currentTime, setCurrentTime] = useState(0);

  const fmtMSS = (s) => {
    return (s - (s %= 60)) / 60 + (9 < s ? ':' : ':0') + ~~s;
  };

  const setupMediaSessions = () => {
    if ('mediaSession' in navigator) {
      console.log('navigator setupped');

      navigator.mediaSession.metadata = new window.MediaMetadata({
        title: title,
        country: country,
        state: state,
        artwork: [
          {
            src: image,
            sizes: '512x512',
            type: 'image/png'
          }
        ]
      });
      navigator.mediaSession.setActionHandler('play', () => {
        /* Code excerpted. */
        toggleAudio();
      });
      navigator.mediaSession.setActionHandler('pause', () => {
        /* Code excerpted. */
        audioPlayer.current.pause();
      });
      // navigator.mediaSession.setActionHandler('previoustrack', () => {
      //   playPrevious();
      // });
      // navigator.mediaSession.setActionHandler('nexttrack', () => {
      //   playNext();
      // });
    }
  };

  const toggleAudio = () => {
    audioPlayer.current
      .play()
      .then((_) => {
        // Automatic playback started!
        // Show playing UI.
        console.log('audio played auto');
        console.log();
        onAddPlayRadioStationStart(stationid);
        setupMediaSessions();
      })
      .catch((error) => {
        // Auto-play was prevented
        // Show paused UI.
        onShowSnackbarNotification(`Radio Station not Available!`);
        console.log('playback prevented');
        setAudioState('paused');
      });
  };

  const handleVolume = (event, newValue) => {
    const q = newValue / 100;
    setStateVolume(q);
    setPreviousVolume(q);
    audioPlayer.current.volume = q;
  };

  const handleMute = (isMute) => {
    if (!isMute) {
      setStateVolume(0);
      audioPlayer.current.volume = 0;
    } else {
      setStateVolume(previousVolume);
      audioPlayer.current.volume = previousVolume;
    }
  };

  /*const handleProgress = (e) => {
    let compute = (e.target.value * dur) / 100;
    setCurrentTime(compute);
    audioPlayer.current.currentTime = compute;
  };*/

  const onFavouriteClick = (id) => {
    const index = heartedStationIds.indexOf(id);

    if (index === -1) {
      onShowSnackbarNotification(`Radio Hearted ❤️`);
      onFavouriteRadioStation(id);
    } else {
      onShowSnackbarNotification(`Radio deleted from favorite 😢`);
      onDeleteHeartRadioStation(id);
    }
  };

  useEffect(() => {
    console.log('changed url', props.url);
    console.log('location.protocol: ', location);
    if (location.protocol === 'https:') {
      props.url.replace(`https:`, `http:`);
    }
    console.log('replaced url: ', props.url.replace(`https:`, `http:`));
    audioPlayer.current.volume = stateVolume;
    if (props.url) {
      setAudioState('loading');
      audioPlayer.current.src = props.url.replace(`https:`, `http:`);
      toggleAudio();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.url]);

  return (
    <>
      <Hidden xsDown>
        <MainPlaybar
          player={player}
          statevolum={stateVolume}
          handleVolume={handleVolume}
          handleMute={handleMute}
          currentTime={fmtMSS(currentTime)}
          audioStatus={audioState}
          toggleAudio={toggleAudio}
          onFavouriteClick={onFavouriteClick}
          onRatingHandle={onRatingHandleStart}
          {...props}
        />
      </Hidden>

      <Hidden smUp>
        <MiniPlaybar
          player={player}
          statevolum={stateVolume}
          handleVolume={handleVolume}
          currentTime={fmtMSS(currentTime)}
          audioStatus={audioState}
          toggleAudio={toggleAudio}
          onFavouriteClick={onFavouriteClick}
          onRatingHandle={onRatingHandleStart}
          {...props}
        />
      </Hidden>

      <audio
        onTimeUpdate={(e) => setCurrentTime(e.target.currentTime)}
        onLoadStart={() => setAudioState('loading')}
        id="audio-element"
        onPlay={() => setAudioState('playing')}
        onPlaying={() => setAudioState('playing')}
        onPause={() => setAudioState('paused')}
        autoPlay
        ref={audioPlayer}
      />
    </>
  );
}
